import React from 'react';
import Button from '../../@base/Button';
import Input from '../../@base/Input';
import AnswersComponent from './AnswersComponent';

/** Componente de detalhamento pergunta e resposta */
const QuestionAnswerDetails = (props) => {
  let { questions } = props.detail;
  const { answers } = props.detail;

  if (questions[questions.length - 1] !== '') {
    questions = [...questions, ''];
  }

  const handleChangeQuestion = (index, e) => {
    const { value } = e.target;
    if (questions !== value) {
      const updatedQuestions = [...questions.filter((i) => i !== '')];
      updatedQuestions[index] = value;
      props.updateQuestion(updatedQuestions);
    }
  };

  const handleRemoveQuestion = (index) => {
    const updatedQuestions = [...questions.filter((i) => i !== '')];
    updatedQuestions.splice(index, 1);
    props.updateQuestion(updatedQuestions);
  };

  const handleChangeAnswer = (answer) => {
    props.updateAnswer(answer);
  };

  return (
    <>
      <div className="float-right mt-1">
        <Button
          small
          primary
          onClick={props.handleBack}
        >
          <small>Salvar e voltar</small>
        </Button>
      </div>
      <div className="row">Responda se alguma dessas perguntas forem identificadas:</div>
      <div className="item-list">
        { questions.map((question, idx) => (
          <div className="row mb-3">
            <div className="col-11">
              <Input
                placeholder={idx === 0 ? 'Escreva a pergunta' : 'Escreva uma variação da pergunta'}
                value={question}
                onChange={(e) => handleChangeQuestion(idx, e)}
              />
            </div>
            <div className="col">
              <Button
                small
                circle
                classes="float-right"
                disabled={questions.length === 1 || question === ''}
                onClick={() => handleRemoveQuestion(idx)}
              >
                <small>
                  <i className="fa fa-times" aria-hidden="true" />
                </small>
              </Button>
            </div>
          </div>
        ))}
        <div />
      </div>
      <div style={{ position: 'relative' }}>
        <div className="mt-3">Respostas:</div>
        <AnswersComponent
          answers={answers}
          handleChangeAnswer={handleChangeAnswer}
        />
      </div>
    </>
  );
};

export default QuestionAnswerDetails;
